import { Container, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { SmsCampaignDto, SmsCampaignService } from "../../../../api/psc";
import {
    EmptyListMessage,
    EndOfInfiniteListMessage,
    PageHeader,
    ScrollToTop,
    Spinner,
    ViewPreference,
} from "../../../../components/exports";
import useDynamicList from "../../../../hooks/UseDynamicList";
import {
    GetViewPreferenceForView,
    SetViewPreferenceForView,
} from "../../../../utils/preferences";
import SmsCampaignListDesktop from "../../components/SmsCampaignListDesktop";
import SmsCampaignListMobile from "../../components/SmsCampaignListMobile";

export default function SmsCampaignList() {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

    const manager = useDynamicList<SmsCampaignDto>((offset) => {
        return SmsCampaignService.listSmsCampaigns("1", offset);
    });

    const [preferDesktop, setPreferDesktop] = useState(
        GetViewPreferenceForView("campaigns") ?? false
    );

    const preferDesktopChange = (preferDesktop: boolean) => {
        SetViewPreferenceForView("campaigns", preferDesktop);
        setPreferDesktop(preferDesktop);
    };

    return (
        <Container
            id="scrollableDiv-campaign-list"
            maxWidth="xl"
            sx={{ height: "100%", overflow: "auto" }}
        >
            <PageHeader
                title="لیست کمپین های پیامکی"
                action={
                    <ViewPreference
                        preferDesktop={preferDesktop}
                        onChange={preferDesktopChange}
                    />
                }
            />

            {manager.requestInProgress && <Spinner />}

            {manager.empty && (
                <EmptyListMessage message="کمپین پیامکی یافت نشد" />
            )}

            {manager.hasData && (
                <InfiniteScroll
                    dataLength={manager.results.length}
                    next={() => {
                        console.log("loadMore");
                        manager.loadMore();
                    }}
                    hasMore={manager.hasMore}
                    loader={<Spinner />}
                    endMessage={<EndOfInfiniteListMessage />}
                    scrollableTarget="scrollableDiv-campaign-list"
                >
                    {isLargeScreen && preferDesktop ? (
                        <SmsCampaignListDesktop
                            smsCampaigns={manager.results}
                        />
                    ) : (
                        <SmsCampaignListMobile smsCampaigns={manager.results} />
                    )}
                </InfiniteScroll>
            )}

            <ScrollToTop />
        </Container>
    );
}
